import { render } from "./NoticiasRelacionadas.vue?vue&type=template&id=097a8edc&scoped=true"
import script from "./NoticiasRelacionadas.vue?vue&type=script&lang=js"
export * from "./NoticiasRelacionadas.vue?vue&type=script&lang=js"

import "./NoticiasRelacionadas.vue?vue&type=style&index=0&id=097a8edc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-097a8edc"]])

export default __exports__